
const TotalWeightLayout = [
    {
        "groupId": 1,
        "label": "Total Weights Current",
        "fields": [
            {
                "name": "NetWeight",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Net Weight",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "readOnly": true
            },
            {
                "name": "GrossWeight",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Gross Weight",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
                "readOnly": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Total Weight New",
        "fields": [
            {
                "name": "UpdatedNetWeight",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Net Weight",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true,
            },
            {
                "name": "UpdatedGrossWeight",
                "tableName": "WMTRANSACTIONDETAIL",
                "label": "Gross Weight",
                "type": "number",
                "format": "#,###0.0000",
                "required": false,
                "visible": true
            }
        ]
    }
];

export {
    TotalWeightLayout
} 
